import * as ReactHighcharts from "react-highcharts";
import {
  IPeerGroupsProps,
  getPeerGroupData,
  IFilter,
  round,
  IVisualizationState,
  IPeerGroupTabsProps,
} from "../../lib/http";
import * as React from "react";
import { Panel } from "react-bootstrap";
import PanelGraph from "app/components/tabs/PanelGraph";

export class AllFoundationLevelsBar extends React.Component<
  IPeerGroupTabsProps,
  IVisualizationState
  > {
  state: IVisualizationState = {
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: -1 },
    title: "",
    loading: false,
    average: [],
    plotLineNumber: 0,
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state;

    data.reverse();

    const currentSet = data.find(
      (dataPoint) => dataPoint.filterId === filters.assetLevel
    );

    const filterOutAllFoundations = data.filter(
      (dataPoint) => dataPoint.filterId > 0
    );

    const filteredOutAllFoundationsSize = filterOutAllFoundations.length;

    const categories = filterOutAllFoundations.map(
      (dataPoint) => dataPoint["IncCon_T_V7_ColName"]
    );

    const selectedColor = "#0070C0";
    const nonSelectedColor = "#D9E1F2";

    const seriesData = filterOutAllFoundations.map((dataPoint) =>
      dataPoint.filterId === filters.assetLevel
        ? {
          y: parseFloat(round(dataPoint.IncCon_N_V6_IncPctYes * 100.0, 1)),
          color: selectedColor,
          filterId: dataPoint.filterId,
        }
        : {
          y: parseFloat(round(dataPoint.IncCon_N_V6_IncPctYes * 100.0, 1)),
          color: nonSelectedColor,
          filterId: dataPoint.filterId,
          borderWidth: 1,
          borderColor: "#a1a1a1",
        }
    );

    const averageData = filterOutAllFoundations.map((dataPoint, index) => {
      const yValue = parseFloat(
        round(dataPoint.IncCon_N_V7_AvgPctIncCon * 100.0, 1)
      );
      return index === 0
        ? {
          y: yValue,
          dataLabels: { enabled: true, format: "Average: {y}%" },
        }
        : { y: yValue };
    });

    const title = currentSet ? currentSet["IncCon_T_B_IncomingAvg"] : "";
    const plotLineNumber = currentSet
      ? parseFloat(round(currentSet["IncCon_N_V7_AvgPctIncCon"] * 100.0, 1))
      : 0;

    const series = [
      {
        color: "#0070C0",
        name: "Percent Incoming Contributions",
        data: seriesData,
        events: { click: (e) => this.updateFilter(e) },
      },
      {
        color: "#a1a1a1",
        name: "Average",
        data: averageData,
        type: "line",
        dashStyle: "ShortDash",
        lineWidth: 3,
        marker: { enabled: false },
      },
    ];

    this.setState({ title, series, categories, plotLineNumber });
  }

  updateFilter(e) {
    if (this.props.onChangeFilterId) {
      this.props.onChangeFilterId(e.point.filterId);
    }
  }

  static getChartConfig(series, categories) {
    const title = "";
    return {
      chart: { type: "bar" },
      title: {
        text: title,
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: true,
        opposite: false,
        title: "",
        labels: {
          format: "{value}%",
        },
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: "{y:,.1f}%",
          },
        },
      },
      legend: { enabled: false },
      credits: { enabled: false },
      series,
    };
  }

  render() {
    const { title, series, loading, categories } = this.state;
    return (
      <PanelGraph
        title={title}
        loading={loading}
        chartConfig={AllFoundationLevelsBar.getChartConfig(series, categories)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/IncomingContributions/AllFoundationLevelsBar/index.tsx